import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';

const actions = createActions({
  TASK: {
    GET_TASKED_CONTENTS: undefined,
    API: {
      GET_TASKED_CONTENTS: apiResourceActionCreator('taskedContents')
    }
  }
})

export const apiAction = (authToken) => commonApiActions.authenticated.get(`${API_ENDPOINT}/tasked-content-ids`, authToken, actions.task.api.getTaskedContents);

function* getTaskedContents(action) {
  const authToken = yield select(authTokenSelector);

  yield put(apiAction(authToken));
}

const configuration = {
  name: 'getTaskedContents',
  action: actions,
  sagas: getTaskedContents,
  reducers: {
    request: (state, action) => ({
      ...state,
      isFetching: true
    }),
    success: (state, action) => ({
      ...state,
      taskedContents: action.payload.taskedContents,
      isFetching: false
    }),
    failed: (state, action) => ({
      ...state,
      isFetching: false
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/task/configurations/getTaskedContents.js